import React, { Component } from "react";
import { Link } from "react-router-dom";

import Header from "../layout/header";
import Footer4 from "../layout/footer4";
import ClientSlider1 from "../element/clientSlider1";
import emailjs from "emailjs-com";
import ReCAPTCHA from "react-google-recaptcha";
import ScrollToTop from "../element/scrollToTop";

const proimage = require("../../images/product/Overbandmagneticspaerator/Overbandmagneticspaerator.webp");
const proimage1 = require("../../images/product/VibroFeeder/DSC01439.webp");

var bnr3 = require("./../../images/banner/bnr3.webp");

class Overbandmagneticspaerator extends Component {
  componentDidMount() {
    window.scrollTo(0, 0);
  }
  constructor(props) {
    super(props);
    this.state = {
      isPopupOpen: false,
      name: "",
      email: "",
      mobile: "",
      showSuccessMessage: false,
      alertMessage: "", // New state for alert message content
      alertType: "", // New state for alert type (success or error)
      captchaToken: "", // New state for captcha token
    };
  }

  openPopup = () => {
    this.setState({ isPopupOpen: true });
  };

  closePopup = () => {
    this.setState({ isPopupOpen: false, alertMessage: "", alertType: "" });
  };
  // Handle captcha change
  handleRecaptchaChange = (token) => {
    this.setState({ captchaToken: token });
  };

      handleDownload = () => {
    const urls = [
      "/pdf/Castomech Catalogue 1.pdf",
      "/pdf/Castomech Catalogue 2.pdf"
    ];
    urls.forEach((url, i) => {
      const link = document.createElement("a");
      link.href = process.env.PUBLIC_URL + url;
      link.download = 'Castomech Catalogue ' + (i + 1) + '.pdf';
      link.style.display = "none";
      document.body.appendChild(link);
      setTimeout(() => {
        link.click();
        document.body.removeChild(link);
      }, i * 500);
    });
  };

  handleInputChange = (e) => {
    const { name, value } = e.target;
    this.setState({ [name]: value });
  };

  handleFormSubmit = (e) => {
    e.preventDefault();
    const { name, email, mobile } = this.state;
    const templateParams = { name, email, mobile, phone: mobile };

    emailjs
      .send(
        "service_28emj8y",
        "template_2rotnxq",
        templateParams,
        "IDZukK49bAWi8Pkt0"
      )
      .then(() => {
        this.setState({
          showSuccessMessage: true,
          alertMessage: "Details submitted successfully! Thank you.",
          alertType: "success",
        });
        this.handleDownload();
        setTimeout(() => this.closePopup(), 3000); // Optional: Close popup after 3 seconds
      })
      .catch((error) => {
        console.error("Failed to send email:", error);
        this.setState({
          alertMessage: "Failed to submit details. Please try again.",
          alertType: "error",
        });
      });
  };

  render() {
    const {
      isPopupOpen,
      name,
      email,
      mobile,
      alertMessage,
      alertType,
      captchaToken,
    } = this.state;
    return (
      <>
        <Header />
        
        {/* --- SIMPLE & CLEAN MINI BANNER --- */}
        <div 
          className="dlab-bnr-inr overlay-black-middle text-center"
          style={{ 
            height: "45vh", 
            minHeight: "350px", 
            backgroundImage: "url(" + bnr3 + ")",
            backgroundSize: "cover",
            backgroundPosition: "center",
            display: "flex",
            alignItems: "center",
            justifyContent: "center",
            position: "relative",
            textAlign: "center"
          }}
        >
          <div className="container" style={{ zIndex: 5, position: "relative", display: "flex", flexDirection: "column", alignItems: "center", justifyContent: "center" }}>
            <div style={{ animation: "fadeUp 1s ease-out", width: "100%" }}>
              <span style={{ color: "#ff4b2b", fontSize: "14px", fontWeight: "700", textTransform: "uppercase", letterSpacing: "3px", display: "block", marginBottom: "15px" }}>Precision Engineering</span>
              <h1 style={{ color: "white", fontSize: "3.5rem", fontWeight: "800", marginBottom: "20px", textShadow: "0 4px 15px rgba(0,0,0,0.4)" }}>
                Overband Magnetic Separator
              </h1>
              <div style={{ width: "60px", height: "4px", background: "#ff4b2b", margin: "0 auto", borderRadius: "2px" }}></div>
            </div>
          </div>
          
          {/* Subtle curved divider */}
          <div style={{ position: "absolute", bottom: "-1px", left: 0, width: "100%", overflow: "hidden", lineHeight: 0 }}>
            <svg viewBox="0 0 1200 120" preserveAspectRatio="none" style={{ position: "relative", display: "block", width: "calc(100% + 1.3px)", height: "40px" }}>
              <path d="M0,0V46.29c47.79,22.2,103.59,32.17,158,28,70.36-5.37,136.33-33.31,206.8-37.5,73.84-4.36,147.54,16.88,218.2,35.26,69.27,18,138.3,24.88,209.4,13.08,36.15-6,69.85-17.84,104.45-29.34C989.49,25,1113,14.29,1200,52.47V0Z" fill="#ffffff" opacity=".25"></path>
              <path d="M0,0V15.81C13,36.92,27.64,56.86,47.69,72.05,99.41,111.27,165,111,224.58,91.58c31.15-10.15,60.09-26.07,89.67-39.8,40.92-19,84.73-46,130.83-49.67,36.26-2.85,70.9,9.42,98.6,31.56,31.77,25.39,62.32,62,103.63,73,40.44,10.79,81.35-6.69,119.13-24.28s75.16-39,116.92-43.05c59.73-5.85,113.28,22.88,168.9,38.84,30.2,8.66,59,6.17,87.09-7.5,22.43-10.89,48-26.93,60.65-49.24V0Z" fill="#ffffff" opacity=".5"></path>
              <path d="M0,0V5.63C149.93,59,314.09,71.32,475.83,42.57c43-7.64,84.23-20.12,127.61-26.46,59-8.63,112.48,12.24,165.56,35.41,78.3,34.2,160.25,37.78,242.09,13.67,61.8-18.2,123.47-52.61,188.91-58.8V0Z" fill="#ffffff"></path>
            </svg>
          </div>
        </div>

        <style dangerouslySetInnerHTML={{__html: `
          @keyframes fadeUp {
            from { opacity: 0; transform: translateY(30px); }
            to { opacity: 1; transform: translateY(0); }
          }
        `}} />

        <br />
        <div className="page-content bg-white">
          <div className="content-block">
            <div className="container">
              <div className="section-full content-inner bg-white video-section">
                <div className="container">
                  <div className="section-content">
                    <div className="row d-flex">
                      <div className="col-md-6" style={{ textAlign: "center" }}>
                        <div className="row">
                          <img
                            className="img-fluid"
                            src={proimage}
                            alt="image"
                          />
                        </div>
                        <div className="blog-post blog-lg blog-rounded ">
                          <button
                            className="site-button black m-r5"
                            type="button"
                            onClick={this.openPopup}
                          >
                            <span className="site-button-inr">
                              Catalogue <i className="ti-download"></i>
                            </span>
                          </button>
                        </div>
                        <div></div>
                      </div>
                      <div className="col-lg-6 col-md-12 m-b30 ">
                        <div className="content-bx1">
                          <label
                            className="gradiant-label"
                            style={{ color: "white", fontSize: "x-large" }}
                          >
                            Overband{" "}
                            <span style={{ color: "#ee4c21" }}>
                              Magnetic Separator
                            </span>
                          </label>
                          <p className="m-b30">
                            <i
                              className="fa fa-gear "
                              style={{
                                fontSize: "18px",
                                fontWeight: "500",
                                marginRight: "10px",
                              }}
                            ></i>
                            Overband Magnetic Separator is designed for continuous duty to
                            separation of tramp iron from the material being carried on
                            the conveyor belt. The separator consists of a heavy duty
                            permanent magnet system or electromagnetic system.
                          </p>
                          <p className="m-b30">
                            <i
                              className="fa fa-gear "
                              style={{
                                fontSize: "18px",
                                fontWeight: "500",
                                marginRight: "10px",
                              }}
                            ></i>
                            It is widely used in foundry, mining, cement, coal and power
                            plants for protecting downstream equipment like crushers,
                            pulverizers, and screens.
                          </p>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
          <div className="container">
            <div className="section-content">
              <ClientSlider1 hideBorder />
            </div>
          </div>
        </div>
        {/* Popup Modal */}
        {alertMessage && (
          <div className={`alert alert-${alertType}`}>
            <strong>{alertType === "success" ? "Success!" : "Error!"}</strong>{" "}
            {alertMessage}
          </div>
        )}

        {/* Popup Modal */}
        {isPopupOpen && (
          <div className="popup-overlay">
            <div className="popup-content">
              <button className="close-button" onClick={this.closePopup}>
                &times;
              </button>
              {alertType === "success" ? (
                <div className="success-message">{alertMessage}</div>
              ) : (
                <>
                  <h4 className="popup-title">Download Catalogue</h4>
                  <p className="popup-subtitle">
                    Enter your details to download
                  </p>
                  <form onSubmit={this.handleFormSubmit}>
                    <div className="popup-form-group">
                      <label>Name</label>
                      <input
                        type="text"
                        name="name"
                        value={name}
                        onChange={this.handleInputChange}
                        required
                      />
                    </div>
                    <div className="popup-form-group">
                      <label>Email</label>
                      <input
                        type="email"
                        name="email"
                        value={email}
                        onChange={this.handleInputChange}
                        required
                      />
                    </div>
                    <div className="popup-form-group">
                      <label>Mobile</label>
                      <input
                        type="tel"
                        name="mobile"
                        value={mobile}
                        onChange={this.handleInputChange}
                        required
                      />
                    </div>
                    <div className="col-lg-12 col-md-12">
                      <div className="form-group">
                        <div className="input-group">
                          <div className="recaptcha-wrapper">
                            <ReCAPTCHA
                              sitekey="6LfJfAgpAAAAAKxWLLAbkYw9Vx1U-WN9fPi66Nsu"
                              onChange={this.handleRecaptchaChange}
                            />
                          </div>
                        </div>
                      </div>
                    </div>
                    <button
                      name="submit"
                      type="submit"
                      value="Submit"
                      className={`site-button button-md ${
                        !captchaToken ? "disabled-button" : ""
                      }`}
                      disabled={!captchaToken} // Disable button if captchaToken is empty
                    >
                      <span>Send</span>
                    </button>
                  </form>
                </>
              )}
            </div>
          </div>
        )}
        <Footer4 />
        <ScrollToTop className="icon-up" />
      </>
    );
  }
}

export default Overbandmagneticspaerator;
